import {useEffect} from 'react'
import {defineMessages} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {getOfferCheckRetryableErrorId} from 'modules/accommodation/selectors'
import {clearOfferCheckRetryableError} from 'modules/accommodation/slice'

import {useToastController} from '@vio/atlas/context/toastController'
import {Icon} from '@vio/atlas/Icon'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

const messages = defineMessages({
  availabilityError: {
    id: 'offerCheck.availabilityError',
    defaultMessage:
      'We couldn’t confirm availability for this room. Please try again'
  }
})

const toastStyle = {width: 'fit-content', minWidth: 'auto'}

/**
 * Shows a one-off toast when a user-initiated offer-check fails with a
 * recoverable site error (transport/server/unexpected, not a confirmed
 * sold-out). The offer stays bookable, so the user can simply retry.
 */
export const useOfferCheckErrorToast = (): void => {
  const dispatch = useDispatch()
  const {open} = useToastController()
  const retryableErrorId = useSelector(getOfferCheckRetryableErrorId)

  useEffect(() => {
    if (!retryableErrorId) return

    open(<FormattedMessageWrapper {...messages.availabilityError} />, {
      icon: <Icon name="WarningTriangle" />,
      showCloseButton: true,
      style: toastStyle
    })

    dispatch(clearOfferCheckRetryableError())
  }, [retryableErrorId, open, dispatch])
}
